import { Box, IconButton } from '@youversion/design-system-components';
import XStroked from '@youversion/design-system-icons/lib/XStroked';
import Modal from 'components/ui/modal';
import ModalHeader from 'components/ui/modal/Header';
import GivingHistory from 'components/views/giving/history';
import { useTranslation } from 'next-i18next';

interface Props {
  onClose: () => void;
}

export default function GivingHistoryDialog({ onClose }: Props) {
  const { t } = useTranslation('common');

  return (
    <Modal onClose={onClose}>
      <Box className='flex flex-col h-full'>
        <ModalHeader
          left={
            <IconButton className='inline-end-2 block-start-2' data-testid='close-modal-button' onClick={onClose}>
              <XStroked className='text-text-light dark:text-text-dark' />
              <label className='sr-only'>{t('giving.cta.close')}</label>
            </IconButton>
          }
          title={t('giving.titles.giving_history')}
        />
        <GivingHistory onClose={onClose} />
      </Box>
    </Modal>
  );
}
